import React, { useState } from 'react';
import BasePracticeMode from '../../common/practice/BasePracticeMode';
import { getAlgorithmSet } from '../../../constants/algorithms';
import { PRACTICE_MODES } from '../../../constants/modes';
import { FormControl, Select, MenuItem } from '@mui/material';
import { logDebug, logError } from '../../../utils/logging';

export default function SinglePLLExecution() {
  const pllSet = getAlgorithmSet('PLL');
  const [selectedAlg, setSelectedAlg] = useState('');
  const [showSolution, setShowSolution] = useState(false);

  const handleAlgorithmChange = (event) => {
    setSelectedAlg(event.target.value);
    setShowSolution(false);
  };

  const handleComplete = (time) => {
    if (typeof time === 'undefined' || time === null) {
      logError('Invalid time value:', time);
      return;
    }

    logDebug('Solve completed:', {
      algorithm: selectedAlg,
      time,
      mode: PRACTICE_MODES.PLL.EXECUTION
    });
  };

  const renderContent = () => {
    if (!selectedAlg) {
      return (
        <div className="algorithm-display">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Select
              value={selectedAlg}
              onChange={handleAlgorithmChange}
              displayEmpty
              placeholder="Select a PLL case"
            >
              <MenuItem value="" disabled>Select a PLL case</MenuItem>
              {Object.values(pllSet.cases).map((alg) => (
                <MenuItem key={alg.id} value={alg.id}>
                  {alg.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <p>Please select a PLL case to practice</p>
        </div>
      );
    }

    const currentCase = pllSet.cases[selectedAlg];

    return (
      <div className="algorithm-display">
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            value={selectedAlg}
            onChange={handleAlgorithmChange}
          >
            {Object.values(pllSet.cases).map((alg) => (
              <MenuItem key={alg.id} value={alg.id}>
                {alg.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <h2>{currentCase.name}</h2>
        <div className="setup-moves">
          <h3>Setup Moves:</h3>
          <p className="algorithm-text">{currentCase.setupAlgorithm}</p>
        </div>
        {showSolution && (
          <div className="solution-moves">
            <h3>Solution:</h3>
            <p className="algorithm-text">{currentCase.algorithm}</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <BasePracticeMode
      mode={PRACTICE_MODES.PLL.EXECUTION}
      title="Single PLL Practice"
      algorithmId={selectedAlg}
      onComplete={handleComplete}
      renderContent={renderContent}
      showSolution={showSolution}
      onToggleSolution={() => setShowSolution(!showSolution)}
      disabled={!selectedAlg}
    />
  );
} 